import { Box, Grid, IconButton, Modal, Typography } from "@mui/material";
import { Close as CloseIcon, Collections as CollectionsIcon } from "@mui/icons-material";
import PlaceholderImg from "../../assets/images/placeholder_img.jpg";
import { useEffect, useState } from "react";
import PictureViewer from "../common/PictureViewer";
import { FETCH_SITES_PROJECTS_PICTURES } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../../common/Loader";

const SiteImages = (props) => {
  const [viewerVisible, setViewerVisible] = useState(false);
  const [viewerIndex, setViewerIndex] = useState(0);
  const [projectImageArray, setProjectImageArray] = useState([]);
  const [groupedImages, setGroupedImages] = useState({});
  const [sortedGroupedImages, setSortedGroupedImages] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedGroupIndex, setSelectedGroupIndex] = useState(null);

  const { loginData } = useSelector((state) => state?.main);

  const openViewer = (index) => {
    setViewerIndex(index);
    setViewerVisible(true);
  };

  const getSiteImages = async (currentPage = 1) => {
    try {
      const obj = {
        SiteId: props?.selectedSite?.id,
        PageNumber: currentPage,
        NrRowsPerPage: 50
      };

      const res = await Postrequestcall(FETCH_SITES_PROJECTS_PICTURES, obj, loginData?.accessToken);

      if (res?.data?.status === true && res?.data?.message === "OK") {
        let newData = res?.data?.data || [];

        // Remove the last 5 records if there are more than 5
        if (newData.length > 5) {
          newData = newData.slice(0, -5);
        } else {
          // if there are 5 or fewer, skip adding any
          newData = [];
        }

        if (newData.length < obj.NrRowsPerPage) {
          setHasMore(false);
        }

        // Group the new data by postId
        const newGroupedData = newData.reduce((groups, image) => {
          const postId = image.postId || 'uncategorized';
          if (!groups[postId]) {
            groups[postId] = [];
          }
          groups[postId].push(image);
          return groups;
        }, {});

        // Merge with existing groups
        setGroupedImages(prevGroups => {
          const updatedGroups = { ...prevGroups };
          Object.keys(newGroupedData).forEach(postId => {
            if (!updatedGroups[postId]) {
              updatedGroups[postId] = [];
            }
            updatedGroups[postId] = [...updatedGroups[postId], ...newGroupedData[postId]];
          });
          return updatedGroups;
        });

        // Sort groups by postId (latest/highest number first)
        const sortedGroups = Object.entries(newGroupedData)
          .sort(([postId1, images1], [postId2, images2]) => {
            // Convert postIds to numbers for comparison, handling non-numeric postIds
            const num1 = parseInt(postId1) || 0;
            const num2 = parseInt(postId2) || 0;
            // Sort by highest postId first
            return num2 - num1;
          });

        setSortedGroupedImages(prev => [...prev, ...sortedGroups]);
        setProjectImageArray((prev) => [...prev, ...newData]);
      }
    } catch (err) {
      console.log("getSiteImages-> Error While Fetching Site Project Picture: ", err);
    }
  };


  useEffect(() => {
    if (props.imageModalOpen) {
      setProjectImageArray([]);
      setGroupedImages({});
      setSortedGroupedImages([]);
      setPage(1);
      setHasMore(true);
      getSiteImages(1);
    }
  }, [props.imageModalOpen]);

  const fetchMoreImages = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    getSiteImages(nextPage);
  };

  return (
    <>
      <Modal open={props?.imageModalOpen}>
        <Box
          className="user-modal-responsive"
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '95%',
            // maxWidth: '1200px',
            height: '90vh',
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              px: 3,
              py: 2,
              borderBottom: "1px solid",
              borderColor: "divider"
            }}>
            <Typography variant="h6" fontWeight={600}>
              {props?.selectedSite?.name}
            </Typography>
            <IconButton
              onClick={() => props.setImageModalOpen(false)}
              sx={{
                "&:hover": {
                  bgcolor: "action.hover"
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Box
            id="scrollableDiv"
            sx={{
              flex: 1,
              overflow: 'auto',
              p: 2,
              '& .infinite-scroll-component': {
                overflow: 'hidden !important'
              }
            }}
          >
            <InfiniteScroll
              dataLength={projectImageArray.length}
              next={fetchMoreImages}
              hasMore={hasMore}
              loader={<Loader />}
              scrollableTarget="scrollableDiv"
              style={{
                overflow: 'visible'
              }}>
              <Grid
                container
                // spacing={1}
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  margin: 0,
                  width: '100%'
                }}>
                {sortedGroupedImages.map(([postId, images], groupIndex) => (
                  <Grid
                    item
                    key={postId}
                    xs={12}
                    sm={6}
                    md={4}
                    sx={{
                      p: 1,
                      width: { xs: '100%', sm: '50%', md: '33.333%' },
                      boxSizing: 'border-box'
                    }}>
                    <Box
                      sx={{
                        position: 'relative',
                        width: '100%',
                        paddingTop: '75%', // 4:3 aspect ratio
                        cursor: 'pointer',
                        borderRadius: 1,
                        overflow: 'hidden',
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          transform: "translateY(-4px)",
                          boxShadow: "0 4px 16px rgba(0,0,0,0.15)"
                        }
                      }}
                      onClick={() => {
                        setSelectedGroupIndex(groupIndex);
                        openViewer(0); // Always start from index 0 for the filtered group
                      }}
                    >
                      <img
                        src={images[0]?.pictureUrl || PlaceholderImg}
                        alt={`Image from group ${postId}`}
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block"
                        }}
                      />
                      {images.length > 1 && (
                        <>
                          <Box
                            sx={{
                              position: 'absolute',
                              top: 10,
                              right: 10,
                              backgroundColor: 'rgba(0, 0, 0, 0.7)',
                              borderRadius: '50%',
                              padding: '6px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                          >
                            <CollectionsIcon sx={{ color: 'white', fontSize: 18 }} />
                          </Box>
                          <Box
                            sx={{
                              position: 'absolute',
                              bottom: 10,
                              right: 10,
                              backgroundColor: 'rgba(0, 0, 0, 0.7)',
                              borderRadius: 1.5,
                              padding: '4px 10px',
                              backdropFilter: 'blur(4px)'
                            }}
                          >
                            <Typography
                              sx={{
                                color: 'white',
                                fontSize: '0.875rem',
                                fontWeight: 600,
                                letterSpacing: '0.5px'
                              }}
                            >
                              +{images.length - 1}
                            </Typography>
                          </Box>
                        </>
                      )}
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </InfiniteScroll>
          </Box>
        </Box>
      </Modal>

      {projectImageArray.length > 0 && (
        <PictureViewer
          isOpen={viewerVisible}
          onClose={() => {
            setViewerVisible(false);
            setSelectedGroupIndex(null);
            props.setImageModalOpen(true);
          }}
          pictures={selectedGroupIndex !== null
            ? sortedGroupedImages[selectedGroupIndex][1].map((pic) => ({
              src: pic.pictureUrl,
              alt: ""
            }))
            : projectImageArray.map((pic) => ({
              src: pic.pictureUrl,
              alt: ""
            }))}
          viewerIndex={viewerIndex}
        />
      )}
    </>
  );
};

export default SiteImages;
